"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "bindMock", {
  enumerable: true,
  get: function get() {
    return _generator.bindMock;
  }
});

var _generator = require("./generator");
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7QUFBQSIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGJpbmRNb2NrIH0gZnJvbSAnLi9nZW5lcmF0b3InO1xuXG5leHBvcnQgeyBiaW5kTW9jayB9Il19